module.exports = __webpack_public_path__ + "img/06.6ad70cfd.jpg";